<template>
    <div class="body-quadrant">
        <div class="item-priority"
             :class="priorityItem.matters.length === 0 ? 'img-priority-' + (priorityIndex+1): ''"
             v-for="(priorityItem, priorityIndex) in priorityItems">
            <div class="text-priority-title"
                 :class="'img-priority-line-' + (priorityIndex+1)">
                {{ priorityItem.name }}
            </div>
            <div class="items-matter">
                <MatterGroup :matterItems="priorityItem.matters"
                             @operateEvent="submitOperate($event)"
                             @clockEvent="submitClock($event)"
                             @matterEvent="submitMatter($event)"/>
                <MatterGroup :matterItems="priorityItem.clockedMatters"
                             @operateEvent="submitOperate($event)"
                             @clockEvent="submitClock($event)"
                             @matterEvent="submitMatter($event)"/>
            </div>
        </div>
    </div>
</template>

<script>
import MatterGroup from "./MatterGroup";
import {mapState} from "vuex";
export default {
    name: "MatterQuadrant",
    components: {
        MatterGroup
    },
    data(){
        return {
            priorityItems: [
                {
                    name: "重要且紧急",
                    matters: [],
                    clockedMatters: [],
                },
                {
                    name: "重要不紧急",
                    matters: [],
                    clockedMatters: [],
                },
                {
                    name: "紧急不重要",
                    matters: [],
                    clockedMatters: [],
                },
                {
                    name: "不重要不紧急",
                    matters: [],
                    clockedMatters: [],
                },
            ],
            openChildArray: [],
        }
    },
    computed: {
        ...mapState("listModules", {
            categoryShowId: state => state.categoryShowId,
        })
    },
    props: {
        matterArray: {
            type: Array,
            default: () => [],
        },
        waitState: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        setPriorityItems: function(){
            // 初始化
            this.priorityItems.forEach((item)=>{
                item.matters = [];
                item.clockedMatters = [];
            })

            this.matterArray.forEach((item)=>{
                if (this.waitState !== item.info.isWaiting){
                    // 待办
                    return
                }else if(this.categoryShowId !== "all" && this.categoryShowId !== item.info.categoryId){
                    return
                }

                const priorityItem = this.priorityItems[item.info.priority - 1];
                if(item.timeInfo.state > 0){
                    priorityItem.clockedMatters.push(item);
                }else{
                    priorityItem.matters.push(item);
                }
            })
        },
        submitOperate: function(e){
            this.$emit("operateEvent", e);
        },
        submitClock: function(e){
            this.$emit("clockEvent", e)
        },
        submitMatter: function(e){
            this.$emit("matterEvent", e)
        },
    },
}
</script>

<style scoped>
div.body-quadrant{
    width: 100%;
    height: calc(100% - 0.56rem);
    box-sizing: border-box;
    padding: 0.2rem 0.5rem;
    /*background: lightcyan;*/
    position: relative;
    display: grid;
    grid-template-columns: calc(50% - 0.1rem) calc(50% - 0.1rem);
    grid-template-rows: calc(50% - 0.1rem) calc(50% - 0.1rem);
    grid-gap: 0.2rem;
    grid-column-gap: 0.2rem;
}
div.item-priority{
    border-radius: 0.16rem;
    border: 0.02rem solid #000000;

    box-sizing: border-box;
    padding: 0.16rem 0.2rem;
    position: relative;

    background-color: #FFFFFF;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 1.82rem 1.82rem;
}
div.img-priority-1{
    background-image: url("../../../../assets/images/List/img-priority-1.png");
}
div.img-priority-2{
    background-image: url("../../../../assets/images/List/img-priority-2.png");
}
div.img-priority-3{
    background-image: url("../../../../assets/images/List/img-priority-3.png");
}
div.img-priority-4{
    background-image: url("../../../../assets/images/List/img-priority-4.png");
}

div.text-priority-title{
    width: 100%;
    height: 0.26rem;
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;

    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 1.1rem 0.08rem;
}

div.img-priority-line-1{
    background-image: url("../../../../assets/images/List/img-priority-line-1.png");
}
div.img-priority-line-2{
    background-image: url("../../../../assets/images/List/img-priority-line-2.png");
}
div.img-priority-line-3{
    background-image: url("../../../../assets/images/List/img-priority-line-3.png");
}
div.img-priority-line-4{
    background-image: url("../../../../assets/images/List/img-priority-line-4.png");
    background-size: 1.3rem 0.08rem;
}
div.items-matter{
    width: 100%;
    height: calc(100% - 0.26rem);
    overflow: auto;
    box-sizing: border-box;
}
</style>